import axios from 'axios';

export const USAGE_ROUTES = {
  USAGE_DATA: '/api/usage/data'
};

export const getUsageData = async ({ from, to, actions }) => {
  const { data } = await axios.get(USAGE_ROUTES.USAGE_DATA, {
    params: { from, to, actions }
  });
  return data;
};
